import { buildMockFormShareLinks } from '@features/forms/constants/mockFormShareLinksApi';
import { UpdateFormSourcesApiRequest } from '@features/forms/types/formSourceApi';

const sourceTrackingEnabledByFormId = new Map<string, boolean>();

const customSourcesByFormId = new Map<
  string,
  { id: number; label: string; form_link: string; icon_url: string }[]
>();

let nextCustomSourceId = 100;

export const buildMockUpdateFormSourcesResponse = (
  formId: string,
  body: UpdateFormSourcesApiRequest
) => {
  const publicUrl = `https://forms.cofee.life/${formId}`;
  const defaultLinks = buildMockFormShareLinks(publicUrl).data;

  if (body.sources?.length) {
    const existing = customSourcesByFormId.get(formId) ?? [];
    const added = body.sources.map((source) => {
      const item = {
        id: nextCustomSourceId,
        label: source.label,
        form_link: `${publicUrl}?utm_source=${source.name}`,
        icon_url: ''
      };
      nextCustomSourceId += 1;
      return item;
    });
    customSourcesByFormId.set(formId, [...existing, ...added]);
  }

  const customLinks = customSourcesByFormId.get(formId) ?? [];
  const sources = body.enable ? [...defaultLinks, ...customLinks] : [];

  sourceTrackingEnabledByFormId.set(formId, body.enable);

  return {
    enable: body.enable,
    sources
  };
};

export const getMockFormShareLinksForForm = (formId: string) => {
  const publicUrl = `https://forms.cofee.life/${formId}`;
  const defaultLinks = buildMockFormShareLinks(publicUrl).data;
  const customLinks = customSourcesByFormId.get(formId) ?? [];
  const isEnabled = sourceTrackingEnabledByFormId.get(formId) ?? true;

  return {
    enable: isEnabled,
    data: isEnabled ? [...defaultLinks, ...customLinks] : []
  };
};
